import React from 'react'
import * as Cookies from "es-cookie";
import CommonHeader from '../navbars/CommonHeader'
import BrandLogo from '../navbars/BrandLogo'

const DEFAULT_VIDEO_NAMES = ["defaultvideo", "fdefaultvideo"];

// NEET / JEE picker shown on the public default-video pages.
function ExamTypePicker({ onChange }) {
    return (
        <div className="ml-auto">
            <div className="custom-control custom-radio custom-control-inline">
                <input type="radio" id="customRadioType1" value="1" name="examtype" className="custom-control-input" onChange={onChange} />
                <label className="custom-control-label text-white" htmlFor="customRadioType1">NEET</label>
            </div>
            <div className="custom-control custom-radio custom-control-inline">
                <input type="radio" id="customRadioType2" value="2" name="examtype" className="custom-control-input" onChange={onChange} defaultChecked={true} />
                <label className="custom-control-label text-white" htmlFor="customRadioType2">JEE</label>
            </div>
        </div>
    );
}

/**
 * Header for the student profile, payment result and public default-video
 * pages: the shared CommonHeader (its own colour). Some of these pages are
 * reachable without logging in, so the user menu only appears with a session.
 *
 * Props: name (page title, or "defaultvideo"/"fdefaultvideo" for the public
 * video pages), handleInputChange (NEET/JEE picker on those pages).
 */
function StudentOrganizationNavbar({ name, handleInputChange }) {
    const isDefaultVideo = DEFAULT_VIDEO_NAMES.includes(name);
    const loggedIn = !!Cookies.get("studenttoken");

    return (
        <CommonHeader
            className="student-organization-navbar"
            color="auto"
            tone="light"
            container={false}
            title={isDefaultVideo ? null : (name || "Student Profile")}
            showUserMenu={loggedIn && !isDefaultVideo}
            left={(
                <React.Fragment>
                    {isDefaultVideo ? null : <BrandLogo fill="#ffffff" width="159.501" />}
                    {isDefaultVideo ? <ExamTypePicker onChange={handleInputChange} /> : null}
                </React.Fragment>
            )}
        />
    );
}

export default StudentOrganizationNavbar
